export default {
      id: "file-text-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#file-text-usage",
      toString: function () {
        return this.url;
      }
    }